<template>
<div>
  <v-alert
    v-if="messageText && alert.type==='error'"
    :color="`${alert.color}`"
    :class="`v-alert v-sheet theme--dark elevation-0 v-alert--dense ${alert.type}`"
    >{{ messageText }}</v-alert
  >
</div>
</template>

<script>
import { mapState } from "vuex";
import UTIL from "src/helpers/utility";

export default {
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),

    messageText() {
      let message = this.alert.message;
      if (!message) {
        message = UTIL.gv(this.alert.message, 'message', '');
      }
      if (!message) {
        message = UTIL.gv(this.alert.message, 'title', '');
      }
      if (!message) {
        return "System encountered an error. Please refresh and try again. If issue persists, contact your administrator.";
      }
      return message;
    }
  },
};
</script>